export enum IncidentUcrLeokaInvolvementType {  
    OfficerKilledFeloniously = 1,
    OfficerKilledByAccident = 2,
    OfficerKilledByNegligence = 3,
    OfficerAssaulted = 4,
    Victim = 5
}